import { getLocalCompanies } from './companyStorage'

export const decoratePointOfWorks = async (pointOfworks) => {
  const count = pointOfworks.reduce((acc, pointOfwork) => {
    ;(acc[pointOfwork.name] = acc[pointOfwork.name] || []).push(pointOfwork)
    return acc
  }, {})

  const items = []
  const seenPairs = new Set()

  for (const [name, group] of Object.entries(count)) {
    const codeCounts = group.reduce((count, pointOfwork) => {
      count[pointOfwork.code] = (count[pointOfwork.code] || 0) + 1
      return count
    }, {})

    for (const pointOfwork of group) {
      const key = `${pointOfwork.name}_${pointOfwork.code}`
      if (seenPairs.has(key)) continue
      seenPairs.add(key)

      const needsCode = group.length > 1 || codeCounts[pointOfwork.code] > 1

      items.push({
        ...pointOfwork,
        name: needsCode
          ? `${pointOfwork.name} - ${pointOfwork.code}`
          : pointOfwork.name
      })
    }
  }
  const withNA = [{ name: 'N/A', code: 'null'}, ...items]

  return { content: withNA }
}
